import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { queryKeys } from '../constants';

export function useCreateDashboard() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (payload: { name: string }) => {
      const { data } = await $api.post('/v1/dashboard', payload);

      return data;
    },
    onSuccess: async () => {
      await qc.invalidateQueries([queryKeys.DASHBOARD_ID]);
    },
    onError: baseErrorHandler
  });
}
